export default __webpack_public_path__ + "static/media/RewardPointsIcon.fb654132.svg";